var map = {
	"./autografika/1.jpg": "de7f",
	"./cerade-baneri/1.jpg": "b1e4",
	"./forekspleksi/1.jpg": "969d",
	"./pvc-naljepnice/1.jpg": "4408",
	"./razno/1.jpg": "d58c",
	"./svijetlece-reklame/1.jpg": "1dfa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "698b";